import React, { useState } from "react";
import Modal from "./Modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function GalleryOne() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalImageTitle, setModalImageTitle] = useState("");

  // Ana sayfa için seçilmiş yurt fotoğrafları - çeşitli kategorilerden
  const homeGalleryImages = [
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (3).jpeg",
      category: "tripleRoom",
      alt: "Haseki Sultan Kız Yurdu - 3 Kişilik Oda",
      title: "Haseki Sultan Kız Yurdu - 3 Kişilik Oda",
    },
    {
      src: "/assets/img/yurt-fotograf/yemekhane/5.jpg",
      category: "diningHall",
      alt: "Haseki Sultan Kız Yurdu - Yemekhane",
      title: "Haseki Sultan Kız Yurdu - Yemekhane",
    },
    {
      src: "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg",
      category: "doubleRoom",
      alt: "Haseki Sultan Kız Yurdu - 2 Kişilik Oda",
      title: "Haseki Sultan Kız Yurdu - 2 Kişilik Oda",
    },
    {
      src: "/assets/img/yurt-fotograf/teras/7.jpg",
      category: "terrace",
      alt: "Haseki Sultan Kız Yurdu - Teras",
      title: "Haseki Sultan Kız Yurdu - Teras",
    },
    {
      src: "/assets/img/yurt-fotograf/etut/1.jpg",
      category: "studyRoom",
      alt: "Haseki Sultan Kız Yurdu - Etüt Odası",
      title: "Haseki Sultan Kız Yurdu - Etüt Odası",
    },
    {
      src: "/assets/img/yurt-fotograf/dis-cephe/33.jpg",
      category: "exterior",
      alt: "Haseki Sultan Kız Yurdu - Dış Cephe",
      title: "Haseki Sultan Kız Yurdu - Dış Cephe",
    },
    {
      src: "/assets/img/yurt-fotograf/banyo/24.jpg",
      category: "bathroom",
      alt: "Haseki Sultan Kız Yurdu - Banyo",
      title: "Haseki Sultan Kız Yurdu - Banyo",
    },
  ];

  // Function to open the modal with the selected image
  const openModal = (image, event) => {
    event.preventDefault();
    setModalImage(image.src);
    setModalImageTitle(image.title);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="gallery-area">
      <div className="container th-container shape-mockup-wrap">
        <div className="title-area text-center">
          {/* <span className="sub-title">{t('nav.generalPhotos')}</span> */}
          <h2 className="sec-title">{t("service.generalPhotos.title")}</h2>
        </div>
        <div className="row gy-10 gx-10 justify-content-center align-items-center">
          {homeGalleryImages.map((image, index) => (
            <div key={index} className="col-md-6 col-lg-2">
              <div className="gallery-card">
                <div className="box-img global-img">
                  <Link
                    to={image.src}
                    className="popup-image"
                    onClick={(e) => openModal(image, e)}
                  >
                    <div className="icon-btn">
                      <i className="fal fa-magnifying-glass-plus" />
                    </div>
                  </Link>
                  <img
                    src={image.src}
                    alt={image.alt}
                    title={image.title}
                    onClick={(e) => openModal(image, e)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          className="shape-mockup d-none d-xl-block"
          style={{
            top: "-25%",
            left: "0%",
          }}
        >
          <img src="/assets/img/shape/line.png" alt="shape" />
        </div>
        <div
          className="shape-mockup movingX d-none d-xl-block"
          style={{
            top: "30%",
            left: "-3%",
          }}
        >
          <img
            className="gmovingX"
            src="/assets/img/shape/shape_4.png"
            alt="shape"
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        imageSrc={modalImage}
        imageTitle={modalImageTitle}
      />
    </div>
  );
}

export default GalleryOne;
